/**
 * Conclusions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    conclusions: [],
    conclusion: {}
};

// Getters
const getters = {
    conclusions: state => {
        return state.conclusions
    },

    conclusion: state => {
        return state.conclusion
    }
};

// Actions
const actions = {
    getConclusions(context, payload) {
        function successCallback(response) {
            //Fetch all conclusions
            // context.commit('getConclusionsHandler', { conclusions: response.data.conclusions });

            //Fetch conclusion of specific consultation
            context.commit('getConclusionsHandler', { conclusions: response.data.consultation.conclusions });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        //Fetch all conclusions
        //makeApiRequest(payload.args, apiModel.Conclusion.List, localToken, successCallback, errorCallback, payload.errorMessages);

        //Fetch conclusions of specific consultation
        makeApiRequest(payload.args, apiModel.Consultation.General.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getConclusion(context, payload) {
        function successCallback(response) {
            context.commit('getConclusionHandler', { conclusion: response.data.conclusion });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Conclusion.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createConclusion(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'conclusions', params: { consultation: response.data.conclusion.consultation_medecine.slug }  });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Conclusion.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateConclusion(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'conclusions' });

            router.push({ name: 'conclusions', params: { consultation: response.data.conclusion.consultation_medecine.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Conclusion.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteConclusion(context, payload) {
        function successCallback(response) {
            context.commit('deleteConclusionHandler', { index: payload.index, successMessage: payload.successMessage,response :response });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Conclusion.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getConclusionsHandler(state, { conclusions }) {
        // Update conclusions state
        state.conclusions = conclusions;
    },

    getConclusionHandler(state, { conclusion }) {
        // Update conclusion state
        state.conclusion = conclusion;
    },

    deleteConclusionHandler(state, { index, successMessage,response }) {
        let i = state.conclusions.findIndex(conclusion => conclusion.slug === index);

        if (~i) {
            state.conclusions.splice(i, 1);

            router.push({ name: 'conclusions', params: { consultation: response.data.conclusion.consultation_medecine.slug } });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}